/* Brickmak: app-like mobile layer (bottom nav, add-to-cart toast, cart badge, home-screen prompt). */
(function () {
  if (window.bmApp) return;
  var mq = window.matchMedia('(max-width: 749.98px)');
  var app = (window.bmApp = { mobile: function () { return mq.matches; } });
  var nav = document.querySelector('[data-bmapp-nav]');
  var toast = document.querySelector('[data-bmapp-toast]');

  /* 1. On phones, adding to cart shows a toast instead of throwing open the cart drawer */
  function setAtc() {
    try { if (window.theme && theme.settings && theme.settings.cartDrawer) {
      if (!app._atc) app._atc = theme.settings.cartDrawer.atcAction;
      theme.settings.cartDrawer.atcAction = mq.matches ? 'none' : app._atc;
    } } catch (e) {}
  }
  setAtc(); mq.addEventListener && mq.addEventListener('change', setAtc);

  function openDrawer(e, from) {
    var d = document.querySelector('cart-drawer');
    if (!d || typeof d.open !== 'function') return false;
    if (e) e.preventDefault();
    if (typeof d.reload === 'function') d.reload();
    setTimeout(function () { d.classList.remove('is-empty'); d.open(from); }, 250);
    return true;
  }

  /* 2. Cart badge + toast: watch the store's own cart requests */
  function setCount(n) {
    document.querySelectorAll('[data-bmapp-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
  }
  function refreshCount() {
    fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
  }
  var tt;
  function showToast(item) {
    if (!toast || !mq.matches) return;
    var img = toast.querySelector('[data-bmapp-toast-img]');
    var src = item && (item.featured_image && item.featured_image.url || item.image);
    if (src) { img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120'; img.hidden = false; } else { img.hidden = true; }
    toast.querySelector('[data-bmapp-toast-title]').textContent = item && (item.product_title || item.title) || '';
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('is-on'); setTimeout(function () { toast.hidden = true; }, 250); }, 3200);
  }
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (res) {
        if (!res.ok) return;
        if (/\/cart\/add/.test(url)) {
          res.clone().json().then(function (j) {
            if (j && !j.status) showToast(j.items ? j.items[0] : j);
          }).catch(function () {});
        }
        setTimeout(refreshCount, 150);
      }).catch(function () {});
    }
    return p;
  };

  /* 3. Nav buttons */
  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var a = e.target.closest('[data-bmapp-shop],[data-bmapp-search],[data-bmapp-cart]');
    if (!a) return;
    if (a.hasAttribute('data-bmapp-cart')) {
      if (toast) { toast.classList.remove('is-on'); }
      if (!document.querySelector('.section-main-cart')) openDrawer(e, a);
      return;
    }
    if (a.hasAttribute('data-bmapp-shop')) {
      var menu = document.querySelector('.header__icon--menu');
      if (menu) { e.preventDefault(); menu.click(); }
      return;
    }
    if (a.hasAttribute('data-bmapp-search')) {
      var input = document.querySelector('#Inline-Search, header input[type="search"]');
      if (input) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function () { input.focus(); }, 250);
      }
    }
  });

  /* 4. Product pages: hide the nav once the sticky add-to-cart bar is on screen */
  var grid = document.querySelector('.section-product-page .product.grid');
  var cta = document.querySelector('.section-product-page .sticky-cta');
  if (nav && grid && cta) {
    var og = document.querySelector('meta[property="og:image"]');
    if (og && !cta.querySelector('.bmapp-cta-img')) {
      var im = document.createElement('img');
      im.className = 'bmapp-cta-img'; im.alt = ''; im.loading = 'lazy';
      im.src = og.content.replace(/^http:/, 'https:') + (og.content.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      cta.insertBefore(im, cta.firstChild);
    }
    var tick = function () {
      var past = grid.getBoundingClientRect().bottom < window.innerHeight - 10;
      nav.classList.toggle('is-hidden', mq.matches && past);
    };
    window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick); tick();
  }

  /* 5. Add to home screen: phones only, from the 2nd page view, once */
  var box = document.querySelector('[data-bmapp-a2hs]');
  var standalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
  var ls = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
             set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  var views = (parseInt(ls.get('bmapp_pv') || '0', 10) || 0) + 1; ls.set('bmapp_pv', views);
  var deferred = null;
  var ios = /iphone|ipad|ipod/i.test(navigator.userAgent) && !/crios|fxios/i.test(navigator.userAgent);
  function maybeShow() {
    if (!box || standalone || !mq.matches || ls.get('bmapp_a2hs') || views < 2) return;
    if (!deferred && !ios) return;
    setTimeout(function () { box.hidden = false; }, 1500);
  }
  window.addEventListener('beforeinstallprompt', function (e) { e.preventDefault(); deferred = e; maybeShow(); });
  if (ios) maybeShow();
  if (box) {
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-bmapp-a2hs-close]')) { box.hidden = true; ls.set('bmapp_a2hs', 'closed'); return; }
      if (e.target.closest('[data-bmapp-a2hs-add]')) {
        if (deferred) {
          deferred.prompt();
          deferred.userChoice.finally(function () { box.hidden = true; ls.set('bmapp_a2hs', 'done'); });
        } else {
          box.querySelector('[data-bmapp-a2hs-text]').textContent = 'Tap the Share icon below, then "Add to Home Screen".';
          e.target.closest('[data-bmapp-a2hs-add]').hidden = true;
          ls.set('bmapp_a2hs', 'shown');
        }
      }
    });
  }
})();
